import React from 'react';
import PropTypes from 'prop-types';
import Pill from './Pill';
import { PILL_TONES, PILL_SIZES, resolveStatusIcon } from './tones';

// A state that changes over time: task status, integration health, upload and indexing progress,
// whether an access URL has been claimed. Rounded rectangle, so it never reads as a label.
//
// Warning and danger always carry an icon — an engineer who cannot tell #fcecd6 from #ffd1cc
// still has to be able to tell "degraded" from "failed". Other tones can pass `icon` where the
// domain benefits from it, but then every state in that set should have one, or the one with an
// icon reads as the special case.
export default function StatusPill({ tone, icon, size, title, className, children }) {
  return (
    <Pill
      tone={tone}
      size={size}
      shape="rect"
      icon={resolveStatusIcon(tone, icon)}
      title={title}
      className={className}
    >
      {children}
    </Pill>
  );
}

StatusPill.propTypes = {
  tone: PropTypes.oneOf(Object.keys(PILL_TONES)).isRequired,
  icon: PropTypes.string,
  size: PropTypes.oneOf(PILL_SIZES),
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

StatusPill.defaultProps = {
  icon: undefined,
  size: 'standalone',
  title: undefined,
  className: '',
};
